import image1 from '../img/culture1.png';
import image2 from '../img/culture2.png';
import image3 from '../img/culture3.png';
import image4 from '../img/culture4.png';
import image5 from '../img/culture5.png';
import image6 from '../img/culture6.png';
import image7 from '../img/culture7.png';
import image8 from '../img/culture8.png';

let cultureData = [
    {
        description: "The Spring 2024 NIBlet class supporting Mandy at her Main Stacks exhibition performance (she killed it!)",
        imageLink: image1,
        alt: "Group of NIB members after a performance",
    },
    {
        description: "NIB members ran the Golden Gate Half Marathon together in Fall 2023!",
        imageLink: image2,
        alt: "4 NIB members after a race",
    },
    {
        description: "Team Kiss the Ground enjoying pumpkin spice lattes on an early morning picnic.",
        imageLink: image3,
        alt: "A project team sitting on grass enjoying coffee",
    },
    {
        description: "The fearless players of Nu Iota Beta, NIB's IM Soccer Team, after their season finale in Spring 2024 (with some special alumni guests!).",
        imageLink: image4,
        alt: "A team after a soccer match",
    },
    {
        description: "Annual photoshoot for our outgoing seniors! We miss you class of 2024 </3",
        imageLink: image5,
        alt: "NIB seniors laughing and smiling together while posing for a picture",
    },
    {
        description: "NIB members dressing up for the wild west while celebrating Jasmine's birthday!",
        imageLink: image6,
        alt: "Group of NIB members dressed in western clothing smiling for a picture",
    },
    {
        description: "Srijani and Jasmine having a great time at our annual summer retreat! This past summer, we went to Shaver Lake for a relaxing weekend.",
        imageLink: image7,
        alt: "4 members on a project team enjoying lunch in the woods",
    },
    {
        description: "Some of our members tabling and greeting potential applicants at Sproul Plaza! Check us out on your way to class :)",
        imageLink: image8,
        alt: "Members posing at the NIB table",
    },
];

export default cultureData;